/* jshint node:true */
"use strict";

module.exports = (function(){

    var uid = "reactApp";

    return {
        "uid" : uid,
        "appDir" : "/app",
        "port" : 1377,
        "host" : "0.0.0.0",
        "proxy" : {
            "port" : 1378,
            "host" : "localhost",
            "url" : ""
        },
        "webpack":{
            "bundler":{
                "port" : 1379,
                "path" : "/assets/js/",
                "publicPath" : "/assets/js/"
            },
            "config":{
                "dev": "webpack.config",
                "prod": "webpack.config.prod"
            }
        },
        "auth" : {
            "user": "rearchitecture",
            "password": "v1e2o3l4"
        },
        "dirs" : {
            "app" : "app",
            "views" : "app/views",
            "rev": "revved"
        },
        "cdn" : {
            "url" : "http://cdn.url.prefix/path",
            "revvedPath" : "/revved"
        },
        "NODE_ENV" : "dev"
    };
}());



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/config/index.js
 **/